/**
 * Lake Charles Community App - Video Library Data
 * Videos stored in Cloudflare R2 bucket
 * Migrated from legacy lake-charles-landing/data/videoLibrary.ts
 */

import type { VideoLibraryItem, VideoCategory } from '@core';

export const lakeCharlesVideoLibrary: VideoLibraryItem[] = [
  // ELECTIONS & VOTING
  {
    id: 'governance-elections-voting',
    category: 'governance',
    icon: '🗳️',
    title: 'Elections & Voting',
    description:
      'Vote for board directors online. Every vote produces a receipt you can check yourself, and a tally anyone can recount. Fast and transparent elections for your community government.',
    duration: '2:26',
    durationSeconds: 146,
    thumbnailUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Voting/elections/elections_image.png',
    videoUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Voting/elections/Screen%20Recording%202025-11-09%20at%203.50.43%E2%80%AFPM.mov',
    featured: true,
  },

  // INFRASTRUCTURE PROPOSALS & CROWDFUNDING
  {
    id: 'governance-infrastructure-proposals',
    category: 'governance',
    icon: '🏗️',
    title: 'Infrastructure Proposals & Crowdfunding',
    description:
      'Fund community projects through collective micro-payments. Vote on infrastructure proposals (trails, parks, etc.), commit funds with escrow protection, and only pay when funding goal is met.',
    duration: '7:31',
    durationSeconds: 451,
    thumbnailUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Voting/infrastructure/infrastructure_image.png',
    videoUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Voting/infrastructure/Screen%20Recording%202025-11-04%20at%209.31.13%E2%80%AFAM.mov',
    featured: true,
  },

  // GROUP BUYING POWER
  {
    id: 'economic-group-buying',
    category: 'economic',
    icon: '💰',
    title: 'Group Buying Power',
    description:
      'See how residents save 58% on oil changes through group buying. Join group deals, commit without paying upfront, and unlock discounts when community thresholds are met.',
    duration: '5:14',
    durationSeconds: 314,
    thumbnailUrl:
      'https://images.unsplash.com/photo-1625047509168-a7026f36de04?w=800&h=600&fit=crop',
    videoUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Group%20Buy/Screen%20Recording%202025-11-04%20at%205.49.19%E2%80%AFAM%20(group-buy).mp4',
    featured: true,
  },

  // VOTER PROFILE
  {
    id: 'governance-voter-profile',
    category: 'governance',
    icon: '📊',
    title: 'Private Voter Profile & Tracking',
    description:
      'Track your votes on city council proposals privately. Compare your positions with community sentiment and understand what matters most to you as a voter.',
    duration: '2:24',
    durationSeconds: 138,
    thumbnailUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Voter%20Profile/voter-profile_image.png',
    videoUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Voter%20Profile/Screen%20Recording%202025-11-09%20at%206.41.27%E2%80%AFPM-voter-profile.mov',
    featured: true,
  },

  // CITY COUNCIL VOTER PROFILE
  {
    id: 'governance-city-council-profile',
    category: 'governance',
    icon: '🏛️',
    title: 'City Council Voting Records',
    description:
      'Access real-time voting records from actual Lake Charles City Council members via public API. Track who voted yes/no on proposals and compare your alignment with each council member.',
    duration: '2:36',
    durationSeconds: 156,
    thumbnailUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/City-Council-Voter-Profile/Screenshot%202025-11-10%20at%207.32.03%E2%80%AFAM%2C%20city-council-voter-profile_image.png',
    videoUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/City-Council-Voter-Profile/Screen%20Recording%202025-11-09%20at%206.23.01%E2%80%AFPM-City-Council-Voter-Profile.mov',
    featured: true,
  },

  // DEPARTMENT CONTACTS & ORG CHART
  {
    id: 'community-department-contacts',
    category: 'community',
    icon: '📧',
    title: 'Department Contacts & Org Chart',
    description:
      'View community department hierarchy and message leaders directly. Browse the org chart, find department directors, and send questions instantly.',
    duration: '3:27',
    durationSeconds: 207,
    thumbnailUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Departments-contact/Screenshot%202025-11-10%20at%207.44.45%E2%80%AFAM-image%20of%20department-contacts.png',
    videoUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Departments-contact/Screen%20Recording%202025-11-04%20at%2010.31.34%E2%80%AFAM-Departments-contact.mov',
    featured: true,
  },

  // APPROVED VENDORS & SERVICE REQUESTS
  {
    id: 'economic-approved-vendors',
    category: 'economic',
    icon: '🛠️',
    title: 'Approved Vendors & Service Requests',
    description:
      'Request services from verified vendors and get competitive bids. Submit lawn care, plumbing, or any service request—vendors bid for your job.',
    duration: '5:46',
    durationSeconds: 346,
    thumbnailUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Marketplace/Approved%20Vendors/Screenshot%202025-11-10%20at%207.59.20%E2%80%AFAM_Approved%20Vendors.png',
    videoUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Marketplace/Approved%20Vendors/Screen%20Recording%202025-11-04%20at%206.25.04%E2%80%AFAM-Approved%20Vendors.mov',
    featured: true,
  },

  // BROWSE LISTINGS & MY LISTINGS
  {
    id: 'community-marketplace-listings',
    category: 'community',
    icon: '🛒',
    title: 'Browse Listings & My Listings',
    description:
      'Sell, rent, or buy items from verified neighbors—no spammers. Post your own listings or browse community marketplace for goods and services.',
    duration: '3:23',
    durationSeconds: 203,
    thumbnailUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Marketplace/Browse-Listings%2BMyListings/Screenshot%202025-11-10%20at%207.59.48%E2%80%AFAM_Browse-Listings%2BMyListings.png',
    videoUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Marketplace/Browse-Listings%2BMyListings/Screen%20Recording%202025-11-04%20at%206.06.41%E2%80%AFAM-Browse-Listings%2BMyListings.mov',
    featured: true,
  },

  // COMMUNITY SERVICES (BOOKING)
  {
    id: 'community-services-booking',
    category: 'community',
    icon: '📅',
    title: 'Community Services (Booking)',
    description:
      'Book community facilities directly in-app without contacting vendors. Browse conference rooms, event venues, and party spaces, check real-time availability, and pay instantly.',
    duration: '2:13',
    durationSeconds: 133,
    thumbnailUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Community%20Services%20(Booking)/Community%20Services%20(Booking)_image.png',
    videoUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Community%20Services%20(Booking)/Community%20Services%20(Booking).mov',
    featured: true,
  },

  // FACEBOOK GROUPS MIGRATION
  {
    id: 'social-facebook-groups',
    category: 'community',
    icon: '📘',
    title: 'Facebook Groups Migration',
    description:
      'Migrate existing Facebook groups into the Community App. Authenticated members, spam reduction, and access to advanced app tools (voting, group buying, services) while retaining familiar UI.',
    duration: '2:53',
    durationSeconds: 173,
    thumbnailUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Social/facebook_groups/facebook_groups_image.png',
    videoUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Social/facebook_groups/facebook_groups.mov',
    featured: true,
  },

  // COMMUNITY NEWS & EVENTS
  {
    id: 'social-community-news',
    category: 'community',
    icon: '📰',
    title: 'Community News & Events Feed',
    description:
      'Browse community news and events in a Substack-style feed. RSVP to events, see attendee counts, and join discussions in a clean Reddit-style layout.',
    duration: '1:18',
    durationSeconds: 78,
    thumbnailUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Social/community_news/community_news_image.png',
    videoUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Social/community_news/community_news.mov',
    featured: true,
  },

  // COMMUNITY FORUM
  {
    id: 'social-community-forum',
    category: 'community',
    icon: '💬',
    title: 'Community Forum & Threads',
    description:
      'Ongoing forum threads for organized discussions, event planning, and Q&A. Like/dislike posts, schedule meetings, and keep conversations focused beyond Facebook.',
    duration: '1:45',
    durationSeconds: 105,
    thumbnailUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Social/community_forum/community_forum_image.png',
    videoUrl:
      'https://lakecharles.media.toolboxlogic.com/Community_App_LakeCharles/Social/community_forum/community%20forum.mov',
    featured: true,
  },
];

// Helper functions
export const getVideosByCategory = (category: VideoCategory): VideoLibraryItem[] => {
  if (category === 'all') return lakeCharlesVideoLibrary;
  return lakeCharlesVideoLibrary.filter((video) => video.category === category);
};

export const getFeaturedVideos = (): VideoLibraryItem[] => {
  return lakeCharlesVideoLibrary.filter((video) => video.featured);
};

export const categoryLabels: Record<VideoCategory, string> = {
  all: 'All Features',
  governance: 'Governance Tools',
  economic: 'Economic Power',
  community: 'Community Engagement',
};

export const categoryIcons: Record<VideoCategory, string> = {
  all: '🎬',
  governance: '🗳️',
  economic: '💰',
  community: '💬',
};

export const categoryDescriptions: Record<VideoCategory, string> = {
  all: 'Explore platform features',
  governance: 'Vote, petition, and propose changes',
  economic: 'Group buying and collective bargaining',
  community: 'Connect, plan, and organize together',
};
